module.exports = __webpack_public_path__ + "img/logo-billo-express.157456b4.svg";